import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import type {
	GridCustomCellProps,
	GridItemChangeEvent,
} from "@tql/ui-components-react/kendo/grid";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type {
	RoutingGuideEnumItem,
	RoutingGuideEnumsType,
} from "~/shared/schemas/routing-guide-schema.ts";

import type { RowUpdate, Rule } from "../../../modal/utils/types.ts";

type ConditionCellProps = GridCustomCellProps & {
	handleRuleRowChange: (event: GridItemChangeEvent | RowUpdate<Rule>) => void;
	isReadOnly: boolean;
	routingGuideEnums?: RoutingGuideEnumsType;
	cellTestId?: string;
};

export const ConditionCell = ({
	handleRuleRowChange,
	isReadOnly,
	routingGuideEnums,
	...props
}: ConditionCellProps) => {
	const dataItem = props.dataItem as Rule;
	const isFirstRow = props.dataIndex === 0;
	const conditions = routingGuideEnums?.conditions ?? [];
	const selectedCondition = isFirstRow
		? (conditions.find((c) => c.name.toLowerCase() === "and") ?? null)
		: (conditions.find(
				(c) => c.name.toLowerCase() === dataItem.condition.toLowerCase(),
			) ?? null);

	return (
		<GridTd data-testid={props.cellTestId} tdProps={props.tdProps}>
			<DropDownList
				data={conditions}
				dataItemKey={"value"}
				disabled={isReadOnly || isFirstRow}
				onChange={(e: DropDownListChangeEvent) => {
					const selected = e.value as RoutingGuideEnumItem;
					handleRuleRowChange({
						dataItem,
						field: "condition" as keyof Rule,
						value: selected.name,
					});
				}}
				textField={"label"}
				value={selectedCondition}
			/>
		</GridTd>
	);
};
